import { createRouter, createWebHistory } from "vue-router";
import ManageBeneficiaries from "@/components/UI/CouponManagement/ManageBeneficiaries.vue";

//Depot Routes
import DepotDetails from "@/views/Depot/DepotDetails.vue";

const routes = [
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Auth/Login"),
  },
  {
    path: "/checkin-code",
    name: "security",
    component: () => import("../views/Security"),
  },
  {
    path: "/checkout-code",
    name: "security checkout",
    component: () => import("../views/Security/checkout"),
  },
  {
    path: "/view-trucks",
    name: "view-trucks",
    component: () => import("../views/Security/viewTables"),
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () => import("../views/Auth/ForgotPassword"),
  },

  {
    path: "/change-password",
    name: "Change Password",
    component: () => import("../views/Auth/ChangePassword"),
  },

  {
    path: "/Account/ResetPassword",
    name: "ResetPassword",
    component: () => import("../views/Auth/ResetPassword"),
  },

  {
    path: "/ConfirmationCode",
    name: "EmailConfirmation",
    component: () => import("../views/Auth/ConfirmEmail"),
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard"),
    isMajor: true,
  },

  {
    path: "/reward",
    name: "Reward",
    component: () => import("../views/Reward"),
    isMajor: true,
  },

  
  {
    path: '/:type?/:id?/beneficiaries',
    name: 'manage-beneficiaries',
    component: () => import("../components/UI/CouponManagement/ManageBeneficiaries.vue"),
    isMajor: true,
    meta: {
      title: 'Manage Beneficiaries',
      breadcrumb: 'Beneficiaries'
    },
    props: route => ({
      programId: route.params.id,
      type: route.params.type || 'coupons',
      ...route.query
    })
  },

  //Tanks

  
  {
    path: "/tanks",
    name: "Tank Viewer",
    component: () => import("../views/Tanks"),
    isMajor: true,
  },

  {
    path: "/live-tanks",
    name: "Live Tanks",
    component: () => import("../views/Tanks/LiveTanks"),
    isMajor: true,
  },

  {
    path: "/tanks",
    name: "Tank Manager",
    component: () => import("../views/Tanks"),
    isMajor: true,
  },

  {
    path: "/tanks",
    name: "Tank Details",
    component: () => import("../views/Tanks/TankDetails.vue"),
    isMajor: true,
  },

  {
    path: "/tank-daily-report",
    name: "Tank Daily Report",
    component: () => import("../views/Tanks/TankReport.vue"),
    isMajor: true,
  },

  {
    path: "/tank-probe",
    name: "Tank Probe",
    component: () => import("../views/Tanks/TankProbe.vue"),
    isMajor: true,
  },

  // {
  //   path: "/tanks",
  //   name: "Tanks",
  //   component: () => import("../views/Tanks"),
  //   isMajor: true,
  // },


  // Payment inflow
  {
    path: "/account-inflow",
    name: "Payment Inflow",
    component: () => import("../views/AccountInflow"),
    isMajor: true,
  },
  {
    path: "/account-inflow-b2b",
    name: "Payment Inflow B2B",
    component: () => import("../views/AccountInflow/b2b"),
    isMajor: true,
  },
  {
    path: "/account-inflow-b2c",
    name: "Payment Inflow B2C",
    component: () => import("../views/AccountInflow/b2c"),
    isMajor: true,
  },

  //Refund Request

  {
    path: "/refund-request",
    name: "Refund Request",
    component: () => import("../views/RefundRequest"),
    isMajor: true,
  },

  {
    path: "/manage-position",
    name: "Manage Position",
    component: () => import("../views/RefundRequest/managePosition"),
  },

  //Depot Routes
  {
    path: "/depot",
    name: "Depot",
    component: () => import("../views/Depot"),
    isMajor: true,
  },

  {
    path: "/Depot-details",
    name: "Depot Details",
    component: () => import("../views/Depot/DepotDetails.vue"),
  },

  //Business Routes

  {
    path: "/business",
    name: "B2B",
    component: () => import("../views/Business"),
    isMajor: true,
  },

  {
    path: "/business-details",
    name: "Business Details",
    component: () => import("../views/Business/businessDetails.vue"),
  },
  {
    path: "/drystockorder-details",
    name: "Drystock Order Details",
    component: () => import("../views/DryStockOrder/Details.vue"),
  },
  {
    path: "/business-approve",
    name: "Business Approve",
    component: () => import("../views/Business/approve.vue"),
  },
  //Orders route
  {
    path: "/orders",
    name: "Business",
    component: () => import("../views/Orders"),
    isMajor: true,
  },
  {
    path: "/order-details",
    name: "Order Details",
    component: () => import("../views/Orders/Details.vue"),
  },

  //CARD MANAGEMGT
  {
    path: "/cards",
    name: "Card Management",
    component: () => import("../views/CardMgt/card-list.vue"),
    isMajor: true,
  },
  {
    path: "/card-details",
    name: "Card Details",
    component: () => import("../views/CardMgt/CardDetails"),
  },
  {
    path: "/maintenance/card-transaction-dates",
    name: "Card Transaction Date Correction",
    component: () => import("../views/Maintenance/CardTransactionDates.vue"),
    isMajor: true,
  },
  //LOYALTY
  {
    path: "/loyalty",
    name: "Loyalty",
    component: () => import("../views/Loyalty"),
    isMajor: true,
  },

  //Stock inventory route
  {
    path: "/stock-inventory",
    name: "Customer",
    component: () => import("../views/StockInventory"),
    isMajor: true,
  },
  {
    path: "/stock-inventory",
    name: "Stock Inventory",
    component: () => import("../views/StockInventory"),
    isMajor: true,
  },

  {
    path: "/product-details",
    name: "Product Details",
    component: () => import("../views/StockInventory/ProductDetails.vue"),
  },

  // Dealer Routes
  {
    path: "/dealer-order-requests",
    name: "Order Request",
    component: () => import("../views/DealerOrderRequest"),
    isMajor: true,
  },

  {
    path: "/dealer-orders",
    name: "Order",
    component: () => import("../views/DealerOrders"),
    isMajor: true,
  },

  // Concession Routes
  {
    path: "/concession",
    name: "Concession",
    component: () => import("../views/Concession"),
    isMajor: true,
  },
  {
    path: "/concession-details",
    name: "Concession Details",
    component: () => import("../views/Concession/Details.vue"),
  },

  //Individual Route
  {
    path: "/individual-details",
    name: "Individual Details",
    component: () => import("../views/User/Details"),
  },

  {
    path: "/users",
    name: "B2C",
    component: () => import("../views/User"),
    isMajor: true,
  },

  {
    path: "/users",
    name: "Users",
    component: () => import("../views/User"),
    isMajor: true,
  },

  //Team Routes

  {
    path: "/teams",
    name: "Dealer",
    component: () => import("../views/Team"),
    isMajor: true,
  },

  {
    path: "/teams",
    name: "Teams",
    component: () => import("../views/Team"),
    isMajor: true,
  },

  {
    path: "/team-details",
    name: "Team Details",
    component: () => import("../views/Team/TeamDetails"),
  },

  //Settings Routes
  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/Settings/"),
    isMajor: true,
  },

  {
    path: "/settings",
    name: "Settings & Control",
    component: () => import("../views/Settings/"),
    isMajor: true,
  },
  // {
  //   path: "/Limit-control",
  //   name: "Limit Control",
  //   component: () => import("../views/Settings/LimitControl.vue"),
  // },
  {
    path: "/Stop-sale",
    name: "Stop Sales",
    component: () => import("../views/Settings/StopSales.vue"),
  },
  {
    path: "/Stock-control",
    name: "Stock Control",
    component: () => import("../views/Settings/StockControl.vue"),
  },
  {
    path: "/Price-control",
    name: "Price Control",
    component: () => import("../views/Settings/PriceControl.vue"),
  },
  {
    path: "/General-settings",
    name: "General Settings",
    component: () => import("../views/Settings/GeneralSettings.vue"),
  },
  {
    path: "/Category-brand-settings",
    name: "Category Brand Settings",
    component: () => import("../views/Settings/CategoryBrandSettings.vue"),
  },
  {
    path: "/Product-settings",
    name: "Product Settings",
    component: () => import("../views/Settings/ProductSettings.vue"),
  },
  {
    path: "/roles-permission",
    name: "Roles and Permissions",
    component: () => import("../views/Settings/RolesAndPermission.vue"),
  },
  {
    path: "/roles-permission-details",
    name: "Roles and Permission Details",
    component: () => import("../views/Settings/PermissionsDetails.vue"),
  },
  {
    path: "/roles-settings",
    name: "Role Setting",
    component: () => import("../views/Settings/RolesSettings.vue"),
  },
  {
    path: "/vouchers",
    name: "Vouchers",
    component: () => import("../views/Vouchers/Vouchers.vue"),
    isMajor: true,
  },

  {
    path: "/edit-role",
    name: "Edit Role",
    component: () => import("../views/Settings/EditRole.vue"),
  },

  {
    path: "/alert-alarm",
    name: "Alert and Alarm",
    component: () => import("../views/Settings/AlertAlarm.vue"),
  },

  //Dry Stock orders

  {
    path: "/dry-stock-order",
    name: "Dry Stock Order",
    component: () => import("../views/DryStockOrder/index.vue"),
    isMajor: true,
  },

  {
    path: "/dry-stock-order/details",
    name: "Dry Stock Details",
    component: () => import("../views/DryStockOrder/Details.vue"),
  },

  //Programs

  {
    path: "/programs",
    name: "Programs",
    component: () => import("../views/Program/index.vue"),
    isMajor: true,
  },

  {
    path: "/schedule-truck",
    name: "Schedule",
    component: () => import("../views/Program/scheduleTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/programmed-trucks",
    name: "Program Truck",
    component: () => import("../views/Program/programmedTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/uliage-trucks",
    name: "Uliage Trucks",
    component: () => import("../views/Program/uliageTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/uliage-trucks",
    name: "Uliage",
    component: () => import("../views/Program/uliageTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/waybill-trucks",
    name: "Waybill",
    component: () => import("../views/Program/waybillTrucks.vue"),
    isMajor: true,
  },

  {
    path: "/program-details",
    name: "Program Details",
    component: () => import("../views/Program/details.vue"),
    isMajor: true,
  },

  {
    path: "/program-details-track",
    name: "Program Details Track",
    component: () => import("../views/Program/details-track.vue"),
  },

  {
    path: "/program-truck",
    name: "Program Truck Details",
    component: () => import("../views/Program/programTruck.vue"),
  },

  {
    path: "/truck-uliage",
    name: "Truck Uliage",
    component: () => import("../views/Program/truckUliage.vue"),
    isMajor: true,
  },

  // Support Routes
  {
    path: "/support",
    name: "Support",
    component: () => import("../views/Support"),
    isMajor: true,
  },

  // Feedback Routes
  {
    path: "/feedback",
    name: "Feedback",
    component: () => import("../views/Feedback"),
    isMajor: true,
  },
  //Security routes

  {
    path: "/safety",
    name: "Safety Check",
    component: () => import("../views/Security/main.vue"),
    isMajor: true,
  },

  {
    path: "/safety",
    name: "Safety",
    component: () => import("../views/Security/main.vue"),
    isMajor: true,
  },

  {
    path: "/safety-checks",
    name: "Safety CheckList",

    component: () => import("../views/Security/testPage.vue"),
    isMajor: true,
  },

  //Change requests
  // {
  //   path: "/change-request",
  //   name: "change-request",
  //   component: () => import("../views/Concession"),
  // },

  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const AUTH_ROUTES = ["Login", "Forgot Password", "Change Password", "ResetPassword", "EmailConfirmation"];
const PUBLIC_ROUTES = ["view-trucks"];

router.beforeEach((to, from, next) => {
  document.title = to && to.name ? `Prudent :: ${to.name}` : "Prudent";

  const isAuthenticated = localStorage.getItem("user-details");

  if (PUBLIC_ROUTES.includes(to.name)) {
    next();
  } else if (AUTH_ROUTES.includes(to.name)) {
    isAuthenticated ? next({ name: "Dashboard" }) : next();
  } else {
    isAuthenticated ? next() : next({ name: "Login" });
  }
});

export default router;
